import { render } from "./ToggelSongs.vue?vue&type=template&id=014579cd"
import script from "./ToggelSongs.vue?vue&type=script&lang=js"
export * from "./ToggelSongs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__